export default {
  list: [
    {
      title: 'آماده سرویس',
      value: 'READY'
    },
    {
      title: 'غیرفعال',
      value: 'DISABLE'
    }
  ],
  value: {
    READY: 'READY',
    DISABLE: 'DISABLE'
  }
}